// extracted by mini-css-extract-plugin
export default {"main":"AsignaturaSelector_main__xKGqe"};